import { Link } from 'react-router-dom';

const articles = [
  {
    title: 'Best Sugargoo Spreadsheet 2026',
    excerpt: 'The ultimate guide to the 2026 edition with verified finds, seller ratings, and smart category filtering.',
    path: '/best-sugargoo-spreadsheet-2026',
    category: 'Featured Guide',
    imgUrl: 'https://readdy.ai/api/search-image?query=Elegant%20flat%20lay%20with%20notebook%20pen%20and%20coffee%20on%20cream%20linen%2C%20warm%20morning%20light%20from%20window%2C%20editorial%20workspace%20photography%2C%20minimalist%20neutral%20aesthetic%2C%20soft%20shadows&width=800&height=500&seq=article-prev-01-v2&orientation=landscape',
  },
  {
    title: 'Updated Sugargoo Spreadsheet June 2026',
    excerpt: 'Latest product additions, refreshed seller links, and improved category organization for summer.',
    path: '/updated-sugargoo-spreadsheet',
    category: 'Latest Update',
    imgUrl: 'https://readdy.ai/api/search-image?query=Fresh%20modern%20minimalist%20calendar%20open%20on%20white%20desk%20with%20succulent%20plant%2C%20warm%20sunlight%2C%20clean%20editorial%20photography%2C%20soft%20neutral%20palette%2C%20organized%20creative%20workspace&width=800&height=500&seq=article-prev-02-v2&orientation=landscape',
  },
  {
    title: 'Sugargoo Spreadsheet by Category',
    excerpt: 'Complete breakdown of all 14 categories with quality standards and browsing tips for each.',
    path: '/sugargoo-spreadsheet-by-category',
    category: 'Category Guide',
    imgUrl: 'https://readdy.ai/api/search-image?query=Colorful%20organized%20folders%20and%20labels%20on%20clean%20white%20desk%2C%20warm%20studio%20lighting%2C%20editorial%20organization%20photography%2C%20minimalist%20creative%20workspace%2C%20soft%20neutral%20background&width=800&height=500&seq=article-prev-03-v2&orientation=landscape',
  },
  {
    title: 'Sugargoo Spreadsheet Brands Guide',
    excerpt: 'How designer-inspired products from Nike, Adidas, Supreme, and Essentials are organized in the sheet.',
    path: '/sugargoo-spreadsheet-brands',
    category: 'Brand Guide',
    imgUrl: 'https://readdy.ai/api/search-image?query=Arrangement%20of%20minimalist%20brand%20tag%20labels%20and%20fabric%20swatches%20in%20warm%20neutral%20tones%20on%20cream%20surface%2C%20editorial%20fashion%20studio%20photography%2C%20soft%20diffused%20lighting&width=800&height=500&seq=article-prev-04-v2&orientation=landscape',
  },
  {
    title: 'Sugargoo QC Guide',
    excerpt: 'Master the art of quality check photo inspection with our pro-level tips and checklist.',
    path: '/sugargoo-qc-guide',
    category: 'QC Guide',
    imgUrl: 'https://readdy.ai/api/search-image?query=Magnifying%20glass%20over%20fabric%20detail%20on%20clean%20white%20desk%2C%20bright%20studio%20lighting%2C%20editorial%20inspection%20photography%2C%20minimalist%20clean%20composition%2C%20warm%20professional%20aesthetic&width=800&height=500&seq=article-prev-05-v2&orientation=landscape',
  },
  {
    title: 'Sugargoo Shipping Guide',
    excerpt: 'Compare shipping lines, costs, and delivery times. Save money with our consolidation tips.',
    path: '/sugargoo-shipping-guide',
    category: 'Shipping Guide',
    imgUrl: 'https://readdy.ai/api/search-image?query=Cardboard%20shipping%20box%20with%20packing%20tape%20on%20clean%20office%20desk%2C%20warm%20natural%20light%2C%20editorial%20logistics%20photography%2C%20minimalist%20soft%20aesthetic%2C%20neutral%20cream%20tones&width=800&height=500&seq=article-prev-06-v2&orientation=landscape',
  },
  {
    title: 'Sugargoo Safety Guide',
    excerpt: 'Identify trustworthy sellers, avoid common scams, and protect your payments on the platform.',
    path: '/sugargoo-safety-guide',
    category: 'Safety Guide',
    imgUrl: 'https://readdy.ai/api/search-image?query=Shield%20icon%20and%20lock%20symbol%20artistically%20arranged%20on%20warm%20cream%20background%2C%20editorial%20security%20concept%20photography%2C%20minimalist%20composition%2C%20soft%20diffused%20lighting%2C%20professional%20trusted%20aesthetic&width=800&height=500&seq=article-prev-07-v2&orientation=landscape',
  },
  {
    title: 'Sugargoo Beginner Guide',
    excerpt: 'Step-by-step walkthrough from account creation to your first successful international haul.',
    path: '/sugargoo-beginner-guide',
    category: 'Beginner Guide',
    imgUrl: 'https://readdy.ai/api/search-image?query=Open%20notebook%20with%20handwritten%20notes%20and%20pen%20on%20warm%20wooden%20desk%2C%20soft%20morning%20light%2C%20editorial%20learning%20photography%2C%20minimalist%20cozy%20workspace%2C%20neutral%20inviting%20aesthetic&width=800&height=500&seq=article-prev-08-v2&orientation=landscape',
  },
  {
    title: 'Best Budget Finds Under $30',
    excerpt: 'Discover the highest-value budget gems that deliver impressive quality without breaking the bank.',
    path: '/best-budget-finds-sugargoo',
    category: 'Budget Guide',
    imgUrl: 'https://readdy.ai/api/search-image?query=Coins%20and%20minimalist%20wallet%20on%20cream%20linen%20fabric%2C%20warm%20sunlight%20casting%20soft%20shadows%2C%20editorial%20savings%20concept%20photography%2C%20clean%20neutral%20aesthetic%2C%20elegant%20simple%20composition&width=800&height=500&seq=article-prev-09-v2&orientation=landscape',
  },
];

export default function ArticlePreviews() {
  return (
    <section id="articles-section" className="py-16 md:py-20 bg-background-100">
      <div className="section-container">
        {/* Header */}
        <div className="flex flex-col md:flex-row md:items-end justify-between mb-12 gap-4">
          <div>
            <p className="text-xs md:text-sm font-medium uppercase tracking-widest text-secondary-600 mb-3">
              Articles &amp; Guides
            </p>
            <h2 className="font-heading text-3xl md:text-5xl font-bold text-foreground-900 leading-tight">
              Everything You Need to Know
              <br />
              <span className="font-heading italic font-normal text-primary-600">About Sugargoo Shopping</span>
            </h2>
          </div>
          <p className="text-sm text-foreground-500 max-w-xs">
            In-depth articles covering every aspect of the Sugargoo spreadsheet experience — from beginner basics to pro-level tips
          </p>
        </div>

        {/* Card Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {articles.map((article) => (
            <Link
              key={article.path}
              to={article.path}
              className="group block bg-background-50 rounded-2xl overflow-hidden hover:scale-[1.02] transition-all duration-300 cursor-pointer"
            >
              {/* Image */}
              <div className="aspect-[16/9] overflow-hidden bg-background-200">
                <img
                  src={article.imgUrl}
                  alt={article.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
              </div>

              {/* Content */}
              <div className="p-5">
                <span className="inline-block text-xs font-medium bg-secondary-100 text-secondary-700 px-2.5 py-1 rounded-full mb-3">
                  {article.category}
                </span>
                <h3 className="font-heading text-base font-semibold text-foreground-900 mb-2 group-hover:text-primary-600 transition-colors">
                  {article.title}
                </h3>
                <p className="text-sm text-foreground-500 leading-relaxed mb-3">
                  {article.excerpt}
                </p>
                <div className="flex items-center gap-1.5 text-primary-600 font-medium text-sm">
                  Read Article
                  <i className="ri-arrow-right-line text-sm group-hover:translate-x-1 transition-transform"></i>
                </div>
              </div>
            </Link>
          ))}
        </div>

        {/* Full spreadsheet CTA */}
        <div className="text-center mt-12 pt-10 border-t border-background-200/60">
          <p className="text-sm text-foreground-500 mb-4">Want to dive straight into the products?</p>
          <a
            href="https://kaspreadsheet.com/"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 bg-primary-500 text-background-50 px-7 py-3.5 rounded-full text-sm font-semibold whitespace-nowrap hover:bg-primary-600 transition-colors cursor-pointer"
          >
            Open Full Sugargoo Spreadsheet
            <i className="ri-arrow-right-up-line text-lg"></i>
          </a>
        </div>
      </div>
    </section>
  );
}